import React from "react";
import Page from "../../components/Page";
import VersionHistoryDetailsComponent from "../../components/VersionHistoryDetails";

export default function VersionHistoryDetails() {
  return (
    <Page>
      <VersionHistoryDetailsComponent />
    </Page>
  );
}
